module.exports = __webpack_public_path__ + "img/003.b7f19dec.svg";